const REQS_TRASLADO = (state, reqs_traslado) => {
    state.reqs_traslado = reqs_traslado;
};

export default {
    REQS_TRASLADO,
};